import React from 'react';
import './heading.scss';
const Heading = (props) => {
    return (React.createElement("div", { className: "heading_wrapper h-26 text-left" }, props.text));
};
export default Heading;
